import React from 'react';


import {  Card, DatePicker,Select} from 'antd';

import moment from 'moment'
//import './Svtoast.css'
import SVRAiport from '../../views/SVRAirport';
import '../../views/AppTa.css'

import '../../css/SearchBar.css'
import SVRAirportDest from '../../views/SVRAirportDest';
const {  RangePicker } = DatePicker;
const { Option } = Select;

const FancySearchBar = () =>{
    //const {filters} = props
    let qt = 'roundtrip'
    
    const getTripHtmlPicker = (qt)=>{
       
        if(qt == 'onewaytrip'){
           

            return (
                
                <div>
                                <br />
                                <Card title="Travel Departure - Return" bordered={false} style={{ width: 300 }}>
                                    <DatePicker  />
                                </Card>
                </div>

            )
            
        }else if(qt == 'roundtrip'){ 
            return (
                
                <div>
                                <br />
                                <Card title="Travel Departure - Return" bordered={false} style={{ width: 300 }}>
                                    <RangePicker  />
                                </Card>
                </div>

            )
            
        }else{

            return (
                
                <div>
                                <br />
                                <Card title="Travel Departure - Return" bordered={false} style={{ width: 300 }}>
                                    <RangePicker  />
                                </Card>
                </div>

            )
        }
        
    }
    
    return (
<div>
    <div className="searchBar">
            <div className="container-fluid">
                <div className="row">
                    <div className="c-container-profilebar">
                        <div className="c-box-profilebar">
                            <span className="c-span">
                                <Select defaultValue="roundtrip" style={{ width: 120 }} >
                                <Option value="roundtrip">Round Trip</Option>
                                <Option value="onewaytrip">One Way</Option>
                                <Option value="multicity" >
                                    Multi City
                                </Option>
                                {/*  <Option value="Yiminghe" disabled>yiminghe</Option>  */}
                               
                                </Select>
                            </span>
                        </div> 
                        <div className="c-box-profilebar">
                            <span className="c-span">
                            <Select defaultValue="t1" style={{ width: 120 }} >
                            <Option value="t1">1 Adult</Option>
                            <Option value="t2">2 Adult</Option>
                            <Option value="t3">3 Adult</Option>
                            <Option value="t4">4 Adult</Option>
                            <Option value="t5">5 Adult</Option>
                            <Option value="t6">6 Adult</Option>
                            
                            </Select>
                            </span>
                </div>
                <div className="c-box-profilebar">
                            <span className="c-span">
                            <Select defaultValue="m0" style={{ width: 120 }} >
                            <Option value="m0">No Child</Option>
                            <Option value="m1">1 Child</Option>
                            <Option value="m2">2 Child</Option>
                            
                            </Select>
                            </span>
                </div>
                <div className="c-box-profilebar">
                            <span className="c-span">
                            <Select defaultValue="ECONOMY" style={{ width: 120 }} >
                            <Option value="c0">Show All </Option>
                            <Option value="ECONOMY">Basic Economy</Option>
                
    
                            <Option value="PREMIUM_ECONOMY">Premium Economy</Option>
                            <Option value="BUSINESS">Business</Option>
                            <Option value="FIRST">First</Option>
                            
                            </Select>
                            </span>
                </div>
                    </div>
                    <div className="c-container-sbar">
                                        <div className="c-box-flybar">
                                            <span className="c-span">
                                            <div>
                        
                                                <br />
                                                <Card title="From"  bordered={false} style={{ width: 300 }}>
                                                
                                                <SVRAiport/>
                                                    </Card>
                                            </div>
                                            
                                            </span>
                                        </div>
                                        <div className="c-box-flybar">
                                            <span className="c-span">
                                            <div>
                                                <br />
                                                <Card title="ToFancy" bordered={false} style={{ width: 300 }}>
                                                <SVRAirportDest></SVRAirportDest>
                                                </Card>
                                            </div>
                                            
                                            </span>
                                        </div>
                                        <div className="c-box-flybar">
                                            <span className="c-span">
                                            {getTripHtmlPicker(qt)}
                                            
                                            </span>
                                        </div>
                                        <div className="c-box-flybar">
                                <span className="c-span">
                                <div>
                                <br />
                                <Card bordered={false}  style={{ width: 300 }}>
                            
                                    <button type="submit" className="btn btn-success" >
                                        SearchFlightsSV
                                    </button> 
                                </Card>
                                </div>
                                </span>
                        </div>
                
                    </div>
                </div>
            </div>
    </div>
</div>
    );
} 


export default FancySearchBar;

/*latesworking


const AppTa = () => (
  <Container className="p-3">
    <Jumbotron>
      <h1 className="header">Welcome To React-Bootstrap</h1>
      <AsyncExample/>
    </Jumbotron>
  </Container>
);


const AppTa = () => (
  <Container className="p-3">
    <Jumbotron>
      <h1 className="header">Welcome To React-Bootstrap</h1>
      <BasicExample/>
    </Jumbotron>
  </Container>
);

*/
/*

function App() {
  return (
    <div className="App">
      <h1>Counter Using useSelector</h1>
      <BasicExample/>
    </div>
  );
}


export default App;


*/